enum CustomerFieldType {
  TEXT = "text",
  EMAIL = "email",
  DATE = "date",
  TOGGLE = "toggle",
  SELECT = "select"
}

export default CustomerFieldType;
